/**
 * Created by root on 8/30/15.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseController = require('web-agent-assets-js/BaseController');

    /*
     * This is an ABSTRACT base class for all lists view controllers in the application.
     * DO NOT insert derived child's implementation - this structure is the architecture of the list and filters.
     * */

    var lpBaseListController = BaseController.extend(function BaseListController(options) {
        this.model = options.model;

        // binding the default context to the outside api's
        this.updateQuery = this.updateQuery.bind(this);

        validateAbstractImplementations.call(this);

        this.initializePersistenceData();
    });

    lpBaseListController.STATES = {
        FETCHING: "fetching",
        FETCHED: "fetched",
        PUBLISHED: "published",
        ERROR: "error"
    };

    lpBaseListController.prototype.applicationType = 'lpBaseListController';
    lpBaseListController.prototype.lastQuery = {};
    lpBaseListController.prototype.settings = {
        defaultSearchUIData: {},
        defaultQueryData: {},
        // TODO: Should this be removed? this should be override by the getModelPaths() function.
        modelPaths: {
            /**
             * the last Query path to save the table query
             */
            lastQuery: null,
            /**
             *
             * the state path to store the list state.
             */
            state: null
        },
        poolingInterval: 2500
    };

    lpBaseListController.prototype.poolingIntervalRef = null;

    lpBaseListController.prototype.initializePersistenceData = function () {
        // initialize data related
        var savedQuery = this.getSessionData({name: this.applicationType, key: "lastQuery"});
        if (typeof(savedQuery) === "undefined" || savedQuery === null || savedQuery === "") {
            savedQuery = this.settings.defaultSearchUIData;
        }
        this.lastQuery = savedQuery;
        this.model.set(this.getModelPaths().lastQuery, this.lastQuery);
    };


    lpBaseListController.prototype.isPolling = function () {
        return this.poolingIntervalRef !== null;
    };

    lpBaseListController.prototype.getDefaultValue = function (valueName) {
        if (valueName) {
            var sValue = valueName.split('.');
            var retVal = this.settings.defaultSearchUIData;
            while (sValue.length) {
                retVal = retVal[sValue.shift()];
            }
            return lpUtils.cloneObject(retVal);
        }
    };

    lpBaseListController.prototype.startPolling = function () {
        if (!this.isPolling()) {
            this.fetch();
            this.poolingIntervalRef = setInterval(this.fetch.bind(this), this.settings.poolingInterval);
        }
    };

    lpBaseListController.prototype.stopPolling = function () {
        if (this.isPolling()) {
            clearInterval(this.poolingIntervalRef);
            this.poolingIntervalRef = null;
        }
    };

    lpBaseListController.prototype.updateQuery = function (searchData) {
        updateQueryData(this, searchData);
        this.fetch(true);
    };

    lpBaseListController.prototype.setState = function (status, message, itemsCount) {
        // setting the status in the state object.
        var stateObj = {
            status: status
        };

        switch (status) {
            case lpBaseListController.STATES.FETCHED:
            case lpBaseListController.STATES.PUBLISHED:
                stateObj.success = message || "ok";
                break;
            case lpBaseListController.STATES.FETCHING:
                break;
            case lpBaseListController.STATES.ERROR:
                stateObj.error = message || "error";
                break;
        }

        // setting the items count if exists.
        if (typeof itemsCount !== 'undefined' && !isNaN(itemsCount)) {
            stateObj.itemsCount = itemsCount;
        }

        // save to the model.
        this.model.set(this.getModelPaths().state, stateObj);
    };

    lpBaseListController.prototype.getStatus = function () {
        return this.model.get(this.getModelPaths().state + '.status');
    };

    lpBaseListController.prototype.clearState = function () {
        return this.model.removeKey(this.getModelPaths().state);
    };

    lpBaseListController.prototype.setSelectedItem = function (selectedItemId) {
        if(this.selectedItemId !== selectedItemId){
            this.selectedItemId = selectedItemId;

            if (_.isFunction(this.onSelectedItemChanged)) {
                this.onSelectedItemChanged({
                    selectedItemId: selectedItemId
                });
            }
        }
    };

    function validateAbstractImplementations() {
        validateAbstractImplementation.call(this, 'fetch');
        validateAbstractImplementation.call(this, 'getModelPaths');
    }

    function validateAbstractImplementation(fnName) {
        if (this[fnName] == lpBaseListController.prototype[fnName]) {
            this.logger.error('[' + fnName + '] abstract function is not implemented.');
        }
    }

    function updateQueryData(context, searchData) {
        var keysToRemove = findKeysToRemove(searchData);
        for (var i = 0; i < keysToRemove.length; i++) {
            context.model.removeKey(context.getModelPaths().lastQuery + '.' + keysToRemove[i]);
        }

        context.model.modify(context.getModelPaths().lastQuery, searchData);
        context.lastQuery = context.model.get(context.getModelPaths().lastQuery);
        context.saveSessionData({name: context.applicationType, key: "lastQuery", value: context.lastQuery});
    }

    function findKeysToRemove(searchData, keysToRemove, path) {
        if (typeof keysToRemove === 'undefined') {
            keysToRemove = [];
        }
        if (typeof path === 'undefined') {
            path = "";
        }
        for (var item in searchData) {
            var itemPath = (path !== "") ? path + '.' + item : item;
            if (typeof searchData[item] === 'undefined') {
                keysToRemove.push(itemPath);
            }
            else if (_.isBasicObject(searchData[item])) {
                findKeysToRemove(searchData[item], keysToRemove, itemPath);
            }
        }
        return keysToRemove;
    }


    /* ------------------ [ Abstract Prototype functions ] ------------------------- */

    /**
     * this function should implement the api/service calls to fetch the new data based on the lastQuery.
     * see implementation example in the abstract function.
     */
    lpBaseListController.prototype.fetch = function () {
        throw new Error('[fetch] method is abstract and must be implemented.');

        /* *** Example Code For Implementation *** */
        //var self = this;
        //var parsedQuery = this.parseQuery;
        //var request = {
        //    query: parsedQuery,
        //    onSuccess: function (data) {
        //        self.setState(lpBaseListController.STATES.FETCHED, "OK", data.items.length);
        //    },
        //    onError: function(err){
        //        self.setState(lpBaseListController.STATES.ERROR, "Error Message");
        //    }
        //};
        //
        //// setting the current state to fetching.
        //this.setState(lpBaseListController.STATES.FETCHING);
        //
        //// Doing the api/service Call
        //lpTag.WebAgent.mySearchService.searchData(request);
    };

    lpBaseListController.prototype.getModelPaths = function () {
        throw new Error('[getModelPaths] method is abstract and must be implemented.');
    };

    return lpBaseListController;

});
